

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';



if (environment.production) {
   enableProdMode();
    window.console.log=function(){};      //  commented = prints ,uncommented = doesnt print
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(" "));





// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/main.ts